export default
{
    legend: {
        layout: 'vertical', align:'center', verticalAlign: 'bottom'

    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'spline',
        animation: true,
        height: '500px',
        time: {
            useUTC: false
        }
        /*
        time: {
            timezone: 'Europe/Bratislava',
            useUTC: false
        }
         */
    },
    title: {
        text: 'Denný UV Index'
    },
    subtitle: {
        text: null
    },
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b',
            hour: '%H:%M'
        },
        gridLineWidth: 1,
        gridLineColor: 'rgba(100,100,100,0.1)',
        lineColor: '#000',
        lineWidth: 1,
        tickColor: '#000',

        tickInterval:30 * 60 * 1000,
        minorTickInterval:15 * 60 * 1000,

        minorGridLineColor: 'rgba(100,100,100,0.05)',

        labels: {
            rotation: -90,
            y:20
        },
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,
        plotLines: [
            /*
            // ciary pre dni
            { color: '#aaa', width: 1, value: 1584748800000},
            { color: '#aaa', width: 1, value: 1584835200000},
            { color: '#aaa', width: 1, value: 1584921600000},
            { color: '#aaa', width: 1, value: 1585008000000},
            { color: '#aaa', width: 1, value: 1585094400000},
            { color: '#aaa', width: 1, value: 1585180800000},
            { color: '#aaa', width: 1, value: 1585267200000},
            { color: '#aaa', width: 1, value: 1585353600000},
            { color: '#aaa', width: 1, value: 1585440000000},
            { color: '#aaa', width: 1, value: 1585526400000},
            { color: '#aaa', width: 1, value: 1585612800000},
            { color: '#aaa', width: 1, value: 1585699200000},
            { color: '#aaa', width: 1, value: 1585785600000},
            { color: '#aaa', width: 1, value: 1585872000000}
            */
            ]


    },
    yAxis: [{
        min: 0,
        opposite: true,
        // max: max_y,
        title: {
            text: 'UV Index'
        },
        minorTickInterval: 0.5,
        minorGridLineWidth:1,
        minorGridLineColor: 'rgba(100,100,100,0.05)',
        gridLineColor: 'rgba(100,100,100,0.1)',

        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        tickInterval: 1,
        tickColor: '#000',
        plotBands:[
        ],
        plotLines:[
            { color: '#129936', width: 2, value: 2},
            { color: '#f0ff00', width: 2, value: 5},
            { color: '#FF8C00', width: 2, value: 7},
            { color: '#b10808', width: 2, value: 10}
        ],

    },{
        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        minorTickInterval: 0.5,
        minorGridLineWidth:1,
        tickColor: '#000',
        title: null,
        labels: {

            enabled: true
        },
    }],
    tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table class="noborder">',
        pointFormat: '<tr><td style="color:{series.color};padding:0;background:none;font-weight:bold;">{series.name}: </td>' +
            '<td style="padding:0;background:none;color:#000">&nbsp;<b>{point.y}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
        backgroundColor: 'rgba(255, 255, 255, 0.85)',
        followPointer: false
    },
    plotOptions: {
        spline: {
            animation: true,
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            marker: {
                enabled: true,
                symbol: 'circle',
                radius: 3,
                states: {
                    hover: {
                        enabled: true,
                        lineWidthPlus: 2
                    }
                }
            },
            states: {
                hover: {
                    enabled: true,
                    lineWidthPlus: 0
                }
            }
        },
        states:{
            hover:{
                enabled:true
            }
        },
        series: {
            states:{
                inactive: {
                    opacity: 1
                }
            },

        }
    },
    series: [
        {id:'uvDaily', name:'UV Index', showInLegend: false, color:'#28bcf2', lineWidth:2, data:[]},
        ]
}
